<template>
  <div class="activity">
    <div class="bg-top"></div>
    <div class="container">
      <div class="toggle">
        <div class="going tab" @click="toggle(true)" :class="active ? 'active' : ''">
          <div>进行中</div>
          <div class="bar" v-show="active"></div>
        </div>
        <div class="end tab" @click="toggle(false)" :class="!active ? 'active' : ''">
          <div>已结束</div>
          <div class="bar" v-show="!active"></div>
        </div>
      </div>
      <div v-show="!active">
        <div class="list" v-for="(item, index) in OverActivityList" :key="index">
          <div class="list-left">
            <div class="col1">
              {{ moment(item.start_time * 1000).format("YYYY/MM/DD") }} - {{ moment(item.end_time * 1000).format("YYYY/MM/DD") }}
            </div>
            <div class="col2">{{ item.desc }}</div>
            <div class="col3">{{ item.title }}</div>
            <router-link :to="`/activity_details/${item.id}`" target="_blank"><div class="col4">查看详情</div></router-link>
            <!-- <div class="col4">查看详情</div> -->
          </div>
          <div class="list-right">
            <img :src="item.thumb_act" alt="" />
          </div>
        </div>
      </div>
      <div v-show="active">
        <div class="list" v-for="(item, index) in OngoingActivityList" :key="index">
          <div class="list-left">
            <div class="col1">
              {{ moment(item.start_time * 1000).format("YYYY/MM/DD") }} - {{ moment(item.end_time * 1000).format("YYYY/MM/DD") }}
            </div>
            <div class="col2">{{ item.title }}</div>
            <div class="col3">{{ item.desc }}</div>
            <router-link :to="`/activity_details/${item.id}`" target="_blank"><div class="col4">查看详情</div></router-link>
          </div>
          <div class="list-right">
            <img :src="item.thumb_act" alt="" />
          </div>
        </div>
      </div>
      <div class="no-activity-yet" v-if="isEmpty">
        <img src="./no_activity_yet.png" alt="" />
        <span>暂无活动</span>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "../../util/http";
import moment from "moment";

export default {
  name: "activity",

  data() {
    return {
      active: true,
      isEmpty: false,
      moment: moment,
      OverActivityList: [],
      OngoingActivityList: [],
    };
  },
  mounted() {
    this.getActivityProfileList();
  },
  methods: {
    toggle(val) {
      this.active = val;
      this.isEmpty = false;
      if (this.active) {
        if (this.OngoingActivityList.length == 0) {
          this.isEmpty = true;
        }
      }
      if (!this.active) {
        if (this.OverActivityList.length == 0) {
          this.isEmpty = true;
        }
      }
    },
    async getActivityProfileList() {
      const {
        data: { data },
      } = await post({ url: "/api/activity/getActivityProfileList" });
      this.OngoingActivityList = data.OngoingActivityList;
      this.OverActivityList = data.OverActivityList;
      if (this.OngoingActivityList.length == 0) {
        this.isEmpty = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.activity {
  margin-top: 0.56rem;
  position: relative;
  .bg-top {
    height: 2.8rem;
    background: url("./bg_top.png") no-repeat;
    background-size: 100% 100%;
  }
  .container {
    margin: 0 auto;
    margin-bottom: 0.4rem;
    width: 12rem;
    .toggle {
      display: flex;
      font-size: 0.16rem;
      color: #999;
      margin: 0.28rem 0;
      .active {
        color: #000;
      }
      .tab {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        .bar {
          margin-top: 0.05rem;
          width: 0.32rem;
          height: 0.04rem;
          background-color: #02a8a2;
          border-radius: 0.02rem;
        }
      }
      .going {
        margin-right: 0.28rem;
      }
    }
    .list {
      display: flex;
      margin-bottom: 0.3rem;
      .list-left {
        width: 3.45rem;
        height: 1.78rem;
        padding: 0.35rem 0;
        background-color: #fff;
        border-radius: 0.1rem 0rem 0rem 0.1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        .col1 {
          font-size: 0.12rem;
          color: #999;
        }
        .col2 {
          width: 1.8rem;
          font-size: 0.18rem;
          color: #333;
          font-weight: bold;
          white-space: nowrap;
          overflow: hidden;
          text-align: center;
          text-overflow: ellipsis;
        }
        .col3 {
          font-size: 0.14rem;
          color: #999;
        }
        .col4 {
          width: 1.08rem;
          height: 0.33rem;
          background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
          border-radius: 0.05rem;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
      .list-right {
        flex: 1;
        height: 1.78rem;
        img {
          width: 100%;
          height: 100%;
          border-radius: 0rem 0.1rem 0.1rem 0rem;
        }
      }
    }
  }
  .no-activity-yet {
    position: absolute;
    left: 50%;
    top: 5.5rem;
    transform: translateX(-50%);
    width: 1.8rem;
    height: 2.2rem;
    text-align: center;
    font-size: 0.18rem;
    color: #a9a9a9;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
